import { UnmappedEntry } from '@modules/accounting-and-finance/interface/default-mapping/default-mapping-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: UnmappedEntry[] = [];

export const ACCGDefaultMappingUnmappedSlice = createSlice({
  name: 'accgDefaultMappingUnmappedEntries',
  initialState,
  reducers: {
    setACCGDefaultMappingUnmappedEntries: (
      _state,
      action: PayloadAction<UnmappedEntry[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGDefaultMappingUnmappedEntries: () => {
      return initialState;
    },
  },
});

export default ACCGDefaultMappingUnmappedSlice.reducer;

export const {
  setACCGDefaultMappingUnmappedEntries,
  removeACCGDefaultMappingUnmappedEntries,
} = ACCGDefaultMappingUnmappedSlice.actions;
